import { render, staticRenderFns } from "./Image3D.vue?vue&type=template&id=6eb48d78&scoped=true&"
import script from "./Image3D.vue?vue&type=script&lang=js&"
export * from "./Image3D.vue?vue&type=script&lang=js&"
import style0 from "./Image3D.vue?vue&type=style&index=0&id=6eb48d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb48d78",
  null
  
)

export default component.exports